module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-messagePush"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('messagePush_title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whiteBox"
  }, [_c('div', {
    staticClass: "switchBox"
  }, [_c('div', {
    staticClass: "swithChice"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('messagePush_receiveAlert')))]), _vm._v(" "), _c('div', {
    staticClass: "swicthBox"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.changeSet
    },
    model: {
      value: (_vm.reqMsg.receiveAlert),
      callback: function($$v) {
        _vm.$set(_vm.reqMsg, "receiveAlert", $$v)
      },
      expression: "reqMsg.receiveAlert"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "switchBox"
  }, [_c('div', {
    staticClass: "swithChice"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('messagePush_receiveSystem')))]), _vm._v(" "), _c('div', {
    staticClass: "swicthBox"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.changeSet
    },
    model: {
      value: (_vm.reqMsg.receiveSystem),
      callback: function($$v) {
        _vm.$set(_vm.reqMsg, "receiveSystem", $$v)
      },
      expression: "reqMsg.receiveSystem"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vAndroid),
      expression: "vAndroid"
    }],
    staticClass: "switchBox"
  }, [_c('div', {
    staticClass: "swithChice"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('messagePush_startApp')))]), _vm._v(" "), _c('div', {
    staticClass: "swicthBox"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.changeSet
    },
    model: {
      value: (_vm.reqMsg.startApp),
      callback: function($$v) {
        _vm.$set(_vm.reqMsg, "startApp", $$v)
      },
      expression: "reqMsg.startApp"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "whiteBox"
  }, [_c('div', {
    staticClass: "switchBox"
  }, [_c('div', {
    staticClass: "swithChice"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('messagePush_vibration')))]), _vm._v(" "), _c('div', {
    staticClass: "swicthBox"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.changeSet
    },
    model: {
      value: (_vm.reqMsg.vibration),
      callback: function($$v) {
        _vm.$set(_vm.reqMsg, "vibration", $$v)
      },
      expression: "reqMsg.vibration"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "switchBox"
  }, [_c('div', {
    staticClass: "swithChice"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('messagePush_voice')))]), _vm._v(" "), _c('div', {
    staticClass: "swicthBox"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.changeSet
    },
    model: {
      value: (_vm.reqMsg.voice),
      callback: function($$v) {
        _vm.$set(_vm.reqMsg, "voice", $$v)
      },
      expression: "reqMsg.voice"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tipBox"
  }, [_vm._v(_vm._s(_vm.$t('messagePush_tipBox')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0ef78fcf","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/messagePush.vue
// module id = 1731
// module chunks = 107